// extracted by mini-css-extract-plugin
module.exports = {"footer":"index_footer_u7tz0","inner":"index_inner_35Qgt","bottom":"index_bottom_28wB8","copyright":"index_copyright_17t-U"};